import Immutable from 'immutable';
import {
  FLAG_GETTING_VOUCHER_TYPES,
  SHOW_ERROR_GETTING_VOUCHER_TYPES,
  CLEAR_ERROR_GETTING_VOUCHER_TYPES,
  GET_VOUCHER_TYPES,
  CLEAR_VOUCHER_TYPES,
  FLAG_GETTING_VOUCHER_TYPE,
  GET_VOUCHER_TYPE,
  CLEAR_VOUCHER_TYPE,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    error: null,
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_VOUCHER_TYPES:
      return state.setIn(['all', 'loading'], action.payload);
    case SHOW_ERROR_GETTING_VOUCHER_TYPES:
      return state.setIn(['all', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_VOUCHER_TYPES:
      return state.deleteIn(['all', 'error']);
    case GET_VOUCHER_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_VOUCHER_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_VOUCHER_TYPE:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_VOUCHER_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_VOUCHER_TYPE:
            return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    default:
      return state;
  }
};
